<template>
  <form-wrap
    class="client-settings"
    @submit="handleUpdate"
  >
    <section-title v-t="'p.clientTagsPage.title'"/>
    <form-field-set>
      <tags-input
        v-model="tags"
        :taggable="true"
        :options="tagsOptions"
        :label-visible="false"
        :full-width="true"
        label="Tags"
        name="tags"
        @tag="addTag"
      />
    </form-field-set>

    <form-actions>
      <button-input
        v-t="'p.clientTagsPage.form.action.submit'"
        type="submit"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import NotificationsMixin from '@/mixins/notifications/notifications'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'ClientSettings',
  mixins: [
    FormMixin,
    NotificationsMixin,
    PageMixin
  ],
  computed: {
    ...mapGetters({
      currentClient: 'currentClient',
      fieldError: 'clientForm/fieldError',
      tagsOptions: 'tagsOptions'
    }),
    tags: {
      get () { return this.$store.state.clientForm.form.tags },
      set (value) { this.$store.dispatch('clientForm/setTags', value) }
    }
  },
  methods: {
    ...mapActions({
      show: 'clientForm/show',
      update: 'clientForm/update',
      resetUpdateErrors: 'clientForm/resetUpdateErrors',
      fetchCurrentUser: 'fetchCurrentUser',
      loadingDone: 'app/loadingDone'
    }),
    addTag (value) {
      this.$store.dispatch('clientForm/setTags', value)
    },
    handleUpdate () {
      return this.update({ clientId: this.currentClient.id })
        .then(this.fetchCurrentUser)
        .then(this.resetUpdateErrors)
        .then(this.savedNotification)
        .catch(this.somethingWentWrongNotification)
    }
  },
  created () {
    this.show({ clientId: this.currentClient.id })
      .then(() => {
        this.loadingDone()
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/ClientTagsPage.vue